import React, { useState, useEffect } from "react";
import { Switch, Route, Router, useHistory } from "../../util/router";
import { Row, Col } from "react-bootstrap";
import Collapsible from "react-collapsible";

import { Link, useRouter } from "../../util/router";
import { useSite } from "../../util/sites";
import { useUser } from "../../util/user";
import GYAxios from "../../util/GYAxios";

import RouteProtect from "./RouteProtect";

import AdminOverview from "./AdminOverview";
import SummaryReport from "./SummaryReportComp/SummaryReport";
import SummaryReportMSA from "./SummaryReportComp/SummaryReportMSA";
import InvoiceContent from "./InvoiceComp/InvoiceContent";
import PaymentRecordVN from "./PaymentRecordComp/PaymentRecordVN";
/* import IssueComp from "./IssueComp"; */
import IssueList from "./IssueList";
import InputEVN from "./InputComp/InputEVN";
import InputMSA from "./InputComp/InputMSA";
import SiteCreationExecutionTable from "./SiteCreationComp/SiteCreationExecutionTable";
import { DownloadContents } from "./DownloadContentsComp/DownloadContents";
import { UploadDataContents } from "./UploadDataContentComp/UploadDataContents";
import { ReceiptContent } from "./ReceiptComp/ReceiptContent";
import { SummaryReportOps } from "./SummaryReportComp/SummaryReportOps";
import SummaryReportOM from "./SummaryReportComp/SummaryReportOM";
import MonthlyLossesRPRReport from "./SummaryReportComp/MonthlyLossesRPRReport";
import ClientUsersContent from "./UserManagement/ClientUsers/ClientUsersContent";
import KeycloakPanelContent from "./UserManagement/KeycloakPanel/KeycloakPanelContent";
import TargetInputs from "./TargetComp/TargetInputs";
import TargetView from "./TargetComp/TargetView";
import TargetViewSummary from "./TargetComp/TargetViewSummary";
import UsersForm from "./UserManagement/ClientUsers/ClientUsersForm/UsersForm";
import UsersFormKC from "./UserManagement/KeycloakPanel/KeycloakUsersForm/UsersFormKC";
import { useUserProps } from "../../util/userDBContext";

// client users form context
import { ProvideClientUsersForm } from "../../util/clientUsersFormContext";

import "./admin.css";
import { useMemo } from "react";
import { ProvideKeycloakUsersForm } from "../../util/keycloakUsersFormContext";

import SiteCreationOperatingTable from "./SiteCreationComp/SiteCreationOperatingTable";
import SiteCreationConstructionTable from "./SiteCreationComp/SiteCreationConstructionTable";
import SiteCreationInvoicingInfoTable from "./SiteCreationComp/SiteCreationInvoicingInfoTable";
import SiteCreationConstructionForm from "./SiteCreationComp/SiteCreationConstructionForm";
import SiteCreationInvoicingForm from "./SiteCreationComp/SiteCreationInvoicingInfoForm";
import SiteCreationRedirect from "./SiteCreationComp/SiteCreationRedirect";
import IssueCalendar from "./IssueCalendarComp/IssueCalendar";
import LandingPage from "./LandingPage/LandingPage";
import {
	AccountBalance,
	AssessmentOutlined,
	AssignmentOutlined,
	BugReportOutlined,
	CloudUploadOutlined,
	FindInPageOutlined,
	GetAppOutlined,
	MonetizationOnOutlined,
	Person,
} from "@material-ui/icons";
import SummaryReportRPRPython from "./SummaryReportComp/SummaryReportRPRPython";

function AdminContents() {
	const currentSite = useSite();
	const router = useRouter();
	const user = useUser();
	const { setLoggedUser, loggedCountry } = useUserProps();
	const history = useHistory();

	const [selectedSite, setSelectedSite] = useState(null);
	const [selectedTab, setSelectedTab] = useState("");
	const [viewLevel, setViewLevel] = useState(null);
	const [isSingleSiteUser, setIsSingleSiteUser] = useState(true);
	const [isOpen, setIsOpen] = useState(false);
	const [userData, setUserData] = useState(null);

	const yellowBarStyle = {
		borderLeft: "gold 10px solid",
	};

	const dropDownStyle = {
		float: "right",
		marginRight: "5px",
		transition: "1s",
	};

	const basepath = "/solar/administration";

	// View permissions
	const viewAdminOverview = user.roles.includes(
		"administration:AdminOverview:_view",
	);
	const viewDataDownload = user.roles.includes(
		"administration:DataDownload:_view",
	);
	const viewUploadData =
		user.roles.includes("_GY:O&M") || user.roles.includes("_GY:IT");
	const viewInvoiceContent =
		user.roles.includes("administration:InvoiceContent:_view") ||
		userData?.see_invoice === 1;
	const viewReceiptContent =
		(user.roles.includes("administration:ReceiptContent:_view") &&
			user.roles.includes("_GY:TH")) ||
		user.roles.includes("_GY:IT");
	const viewPaymentRecordVN =
		(user.roles.includes("administration:InvoiceContent:_view") &&
			user.roles.includes("_GY:VN") &&
			user.roles.includes("_GY:Accounting")) ||
		user.roles.includes("_GY:IT") || user.roles.includes("administration:PaymentRecordVN:_view");
	const viewSummaryReport = user.roles.includes(
		"administration:SummaryReport:_view",
	);
	const viewMSAReport =
		(viewSummaryReport && user.roles.includes("_GY:TH")) ||
		user.roles.includes("_GY:IT");
	const viewICRPRReport =
		(viewSummaryReport &&
			user.roles.includes("administration:ICRPRReport:_view")) ||
		user.roles.includes("_GY:IT");
	const viewIssueComp = user.roles.includes("administration:IssueComp:_view");
	const viewTarget = user.roles.includes("administration:TargetContent:_view");

	const viewClientUsers = user.roles.includes(
		"administration:ClientUsersContent:_view",
	);
	const viewKeycloakPanel = user.roles.includes(
		"administration:KeycloakPanelContent:_view",
	);
	const viewInputs = user.roles.includes(
		"administration:InputMSA:_contribute",
		"administration:InputEVN:_contribute",
	);
	const viewEVNInput =
		(user.roles.includes("administration:InputEVN:_contribute") &&
			user.roles.includes("_GY:VN")) ||
		user.roles.includes("_GY:IT");
	const viewMSAInput =
		(user.roles.includes("administration:InputMSA:_contribute") &&
			user.roles.includes("_GY:TH")) ||
		user.roles.includes("_GY:IT");
	const viewSiteCreation = user.roles.includes(
		"administration:SiteCreation:_view",
	);

	const viewAccountingTab =
		viewInvoiceContent || viewReceiptContent || viewPaymentRecordVN;

	// this control the visibility in component level
	const requiredRoles = useMemo(
		() => ({
			adminOverview: [["administration:AdminOverview:_view"]],
			downloadContents: [["administration:DataDownload:_view"]],
			uploadContents: [["_GY:O&M"], ["_GY:IT"]],
			billingLandingPage: [
				["administration:InvoiceContent:_view"],
				["administration:InvoiceTable:_clientViewInv"],
				["administration:ReceiptContent:_view"],
				["administration:PaymentRecordVN:_view"],
			],
			invoiceContent: [
				["administration:InvoiceContent:_view"],
				["administration:InvoiceTable:_clientViewInv"],
			],
			receiptContent: [
				["administration:ReceiptContent:_view", "_GY:TH"],
				["_GY:IT"],
			],
			issueList: [["administration:IssueComp:_view"]],
			targetView: [["administration:TargetContent:_view"]],
			targetInputs: [["administration:TargetContent:_view"]],
			userLandingPage: [
				["administration:ClientUsersContent:_view"],
				[
					"administration:KeycloakPanelContent:_view",
					"administration:ClientUsersContent:_edit",
				],
			],
			clientUsersContent: [["administration:ClientUsersContent:_view"]],
			userForm: [
				[
					"administration:ClientUsersContent:_view",
					"administration:ClientUsersContent:_edit",
				],
			],
			keycloakPanelContent: [["administration:KeycloakPanelContent:_view"]],
			usersFormKC: [
				[
					"administration:KeycloakPanelContent:_view",
					"administration:KeycloakPanelContent:_edit",
				],
			],
			input: [
				["administration:InputMSA:_contribute"],
				["administration:InputEVN:_contribute"],
			],
			inputEVN: [["administration:InputEVN:_contribute"]],
			inputMSA: [["administration:InputMSA:_contribute"]],
			siteCreation: [["administration:SiteCreation:_view"]],
			summaryReport: [["administration:SummaryReport:_view"]],
			summaryReportMSA: [
				["administration:SummaryReport:_view", "_GY:TH"],
				["_GY:IT"],
			],
			summaryReportOps: [["administration:SummaryReport:_view"]],
			monthlyLossesRPRReport: [
				[
					"administration:SummaryReport:_view",
					"administration:ICRPRReport:_view",
				],
			],
			SummaryReportRPRPython: [["administration:SummaryReport:_view"]],
			paymentRecordVN: [
				["administration:PaymentRecordVN:_view"],
				["administration:InvoiceContent:_view", "_GY:VN", "_GY:Accounting"],
				["_GY:IT"],
			],
		}),
		[],
	);

	const navBarItems = useMemo(
		() => [
			{
				key: "om-extract",
				label: "O&M Extract",
				path: "/solar/administration/overview",
				icon: (props) => <FindInPageOutlined {...props} />, //'glyphicon-pencil',
				show: viewAdminOverview,
			},
			{
				key: "data-download",
				label: "Data Download",
				path: "/solar/administration/download",
				icon: (props) => <GetAppOutlined {...props} />, // 'glyphicon-download',
				show: viewDataDownload,
			},
			{
				key: "upload-data",
				label: "Upload Data",
				path: "/solar/administration/upload",
				icon: (props) => <CloudUploadOutlined {...props} />, // 'glyphicon-upload',
				show: viewUploadData,
			},
			{
				key: "billing",
				label: "Billing",
				icon: (props) => <MonetizationOnOutlined {...props} />, // 'glyphicon-save-file',
				show: viewAccountingTab,
				path: "/solar/administration/billing",
				children: [
					{
						label: "Invoice / Report",
						path: "/solar/administration/billing/invoice",
						show: viewInvoiceContent,
					},
					{
						label: "Receipt",
						path: "/solar/administration/billing/receipt",
						show: viewReceiptContent,
					},
					{
						label: "Payment Record",
						path: "/solar/administration/billing/payment-record",
						show: viewPaymentRecordVN,
					},
				],
			},
			{
				key: "summary-report",
				label: "Summary Report",
				icon: (props) => <AssessmentOutlined {...props} />, // 'glyphicon-list-alt',
				show: viewSummaryReport,
				path: "/solar/administration/summary",
				children: [
					{
						label: "Revenue Report",
						path: "/solar/administration/summary/accounting",
						show: viewSummaryReport,
					},
					{
						label: "O&M",
						path: "/solar/administration/summary/ops",
						show: viewSummaryReport,
					},
					{
						label: "New O&M",
						path: "/solar/administration/summary/newom",
						show: viewSummaryReport,
					},
					{
						label: "O&M Report (Python)",
						path: "/solar/administration/summary/rpr_python",
						show: viewSummaryReport,
					},
					{
						label: "IC Report - COD",
						path: "/solar/administration/summary/lossesRPR",
						show: viewICRPRReport,
					},
					{
						label: "MSA Report",
						path: "/solar/administration/summary/msa",
						show: viewMSAReport,
					},
				],
			},
			{
				key: "issue-list",
				label: "Issue List",
				path: "/solar/administration/issue",
				icon: (props) => <BugReportOutlined {...props} />, //, 'glyphicon-save-file',
				show: viewIssueComp,
			},
			{
				key: "issue-calendar",
				label: "Issue Calendar",
				path: "/solar/administration/issue-calendar",
				icon: (props) => <BugReportOutlined {...props} />, //, 'glyphicon-save-file',
				show: viewIssueComp,
			},
			{
				key: "site-creation",
				label: "Site Creation",
				icon: (props) => <AccountBalance {...props} />, // 'glyphicon-screenshot',
				show: viewTarget || viewSiteCreation,
				path: "/solar/administration/site-creation",
				children: [
					{
						label: "Manage Sites",
						path: "/solar/administration/site-creation/manage-site/redirect",
						show: viewSiteCreation,
						subChildrenPaths: [
							"/solar/administration/site-creation/manage-site/execution-table",
							"/solar/administration/site-creation/manage-site/operating-table",
							"/solar/administration/site-creation/manage-site/construction-table",
							"/solar/administration/site-creation/manage-site/construction-form",
							"/solar/administration/site-creation/manage-site/invoicing-info-table",
							"/solar/administration/site-creation/manage-site/invoicing-info-form",
						],
					},
					{
						label: "Target Table",
						path: "/solar/administration/site-creation/target-table",
						show: viewTarget,
					},
					{
						label: "Target Table Summary",
						path: "/solar/administration/site-creation/target-summary",
						show: viewTarget,
					},
					{
						label: "Target Inputs",
						path: "/solar/administration/site-creation/target-input",
						show: viewTarget,
					},
				],
			},
			{
				key: "user-management",
				label: "User Management",
				icon: (props) => <Person {...props} />, // 'glyphicon-user',
				show: viewClientUsers || viewKeycloakPanel,
				path: "/solar/administration/users",
				children: [
					{
						label: "Client Users",
						path: "/solar/administration/users/clients",
						show: viewClientUsers,
					},
					{
						label: "Keycloak Panel",
						path: "/solar/administration/users/GY",
						show: viewKeycloakPanel,
					},
				],
			},
			{
				key: "inputs",
				label: "Inputs",
				icon: (props) => <AssignmentOutlined {...props} />, // 'glyphicon-save-file',
				show: viewInputs,
				path: "/solar/administration/input",
				children: [
					{
						label: "EVN Input",
						path: "/solar/administration/inputevn",
						show: viewEVNInput,
					},
					{
						label: "MSA Input",
						path: "/solar/administration/inputmsa",
						show: viewMSAInput,
					},
				],
			},
		],
		[
			viewAccountingTab,
			viewAdminOverview,
			viewClientUsers,
			viewDataDownload,
			viewUploadData,
			viewEVNInput,
			viewInputs,
			viewInvoiceContent,
			viewIssueComp,
			viewKeycloakPanel,
			viewMSAInput,
			viewMSAReport,
			viewICRPRReport,
			viewPaymentRecordVN,
			viewReceiptContent,
			viewSiteCreation,
			viewSummaryReport,
			viewTarget,
		],
	);

	const renderNavBarIcon = (icon) =>
		typeof icon === "string" ? (
			<span className={`glyphicon ${icon}`} aria-hidden="true"></span>
		) : typeof icon === "function" ? (
			<span style={{ marginRight: "0.2em" }}>
				{icon({ style: { fontSize: "1.4em", verticalAlign: "text-bottom" } })}
			</span>
		) : null;

	const renderNavBarItem = (navBarItem) => {
		const children = navBarItem.children?.filter((child) => child.show);
		if (!(navBarItem.show && (!children || children.length))) {
			return null;
		}
		// render nav bar item with no children
		if (!children) {
			// active based on route path
			const active = navBarItem.path === router.pathname;
			// active based on isOpen
			// const active = isOpen === navBarItem.key;
			return (
				<Link
					key={navBarItem.key}
					to={navBarItem.path}
					className="list-group-item"
					style={active ? yellowBarStyle : {}}
					onClick={() => openTab(navBarItem.key)}
				>
					{renderNavBarIcon(navBarItem.icon)}
					{navBarItem.label}
				</Link>
			);
		}
		// render nav bar item with only 1 visible child
		if (children?.length === 1) {
			// active based on route path
			const active =
				children[0].path === router.pathname ||
				children[0].subChildrenPaths?.includes(router.pathname);
			// active based on isOpen
			// const active = isOpen === navBarItem.key;
			return (
				<Link
					key={navBarItem.key}
					to={children[0].path}
					className="list-group-item"
					style={active ? yellowBarStyle : {}}
					onClick={() => openTab(navBarItem.key)}
				>
					{renderNavBarIcon(navBarItem.icon)}
					{navBarItem.label}
				</Link>
			);
		}
		// render nav bar item with multiple visible children
		if (children?.length > 1) {
			// active based on route path
			const active =
				navBarItem.path === router.pathname ||
				children.some(
					(child) =>
						child.path === router.pathname ||
						child.subChildrenPaths?.some((path) => path === router.pathname),
				);
			// active based on isOpen
			// const active = isOpen === navBarItem.key;
			const childLinkActive = (active) => (active ? "active" : "");
			return (
				<Collapsible
					key={navBarItem.key}
					trigger={
						<span
							className="list-group-item"
							style={active ? yellowBarStyle : {}}
							onClick={() => navBarItem.path && history.push(navBarItem.path)}
						>
							{renderNavBarIcon(navBarItem.icon)}
							{navBarItem.label}
							<span
								className={
									!isOpen || isOpen !== navBarItem.key
										? "glyphicon glyphicon-menu-down"
										: "glyphicon glyphicon-menu-up"
								}
								aria-hidden="true"
								style={dropDownStyle}
							></span>
						</span>
					}
					transitionTime="200"
					easing="ease-in"
					onOpening={() => openTab(navBarItem.key)}
					open={isOpen === navBarItem.key}
					onTriggerClosing={() => closeTab()}
				>
					<ul
						style={{
							padding: "0",
							margin: "0",
							listStyleType: "none",
							backgroundColor: "#eae8d9",
						}}
					>
						{children.map((child) => (
							<Link
								key={child.path}
								className={`sub-list-item ${childLinkActive(child.path === router.pathname || child.subChildrenPaths?.some((path) => path === router.pathname))}`}
								to={child.path}
							>
								<li>{child.label}</li>
							</Link>
						))}
					</ul>
				</Collapsible>
			);
		}
	};

	/**
	 * Validate if user has only single site
	 * @param {Logged in user} user
	 * @returns boolean - user with only 1 site
	 */
	const validateSingleSiteUser = (user) => {
		const KCToken = user.sub;

		GYAxios.get(`/users/filter?column=keycloak_id&value=${KCToken}`).then(
			(res) => {
				const userInfo =
					res.data.error == null && res.data.length > 0 ? res.data[0] : false;
				setUserData(userInfo);
				if (userInfo) {
					setLoggedUser(userInfo);
					// Admin user
					if (user.roles.includes("_GY:Base")) return false;
					// Solo client user
					else if (userInfo.client_id == null) return true;
					else if (userInfo.site_id != null) {
						const siteIDArr = userInfo.site_id.toString().split(",");

						// Single site user
						if (siteIDArr.length === 1) return true;
						// Multi site user
						else return false;
					}
					// Client user
					else return false;
				} else return false;
			},
		);
	};

	/**
	 * Validate permission level of invoice sites accessible
	 * by user based on roles
	 * @param {Roles of user} roles
	 */
	const validateViewLevel = (roles) => {
		// O&M and IT & Management
		let level = 1;

		// Accounting access to approve invoice
		if (roles.includes("_GY:Accounting")) level = 2;
		// Clients' access to view approved invoice
		else if (roles.includes("administration:InvoiceTable:_clientViewInv"))
			level = 3;
		return level;
	};

	/**
	 * Open tab
	 * @param {string} tab
	 * @returns
	 */
	const openTab = (tab) => setIsOpen(tab);

	/**
	 * Close tab
	 */
	const closeTab = () => setIsOpen(false);

	useEffect(() => {
		// View level
		const viewLevel = validateViewLevel(user.roles);
		setViewLevel(viewLevel);

		// Verify if user is a single site user
		const singleUserValidation = validateSingleSiteUser(user);
		setIsSingleSiteUser(singleUserValidation);
	}, []);

	// Validate site -  Redirect if 'All Sites' is selected
	useEffect(() => {
		const siteID = sessionStorage.getItem("site_id");
		if (
			currentSite.selectedSite?.label !== currentSite.defaultSelect?.label ||
			siteID != null
		)
			setSelectedSite(currentSite.selectedSite);
	}, [currentSite.selectedSite]);

	// Show site select bar before leaving Admin page
	useEffect(() => {
		window.localStorage.setItem("loadingAdminPage", true);
		const pathname = router.pathname;

		switch (pathname) {
			case `${basepath}/download`:
				setSelectedTab("DOWNLOAD");
				break;
			case `${basepath}/invoice`:
				setSelectedTab("INVOICE");
				break;
			case `${basepath}/receipt`:
				setSelectedTab("RECEIPT");
				break;
			case `${basepath}/summary/ops`:
				setSelectedTab("SUMMARY_OPS");
			case `${basepath}/summary/om`:
				setSelectedTab("SummaryReportOM");
				break;
			case `${basepath}/summary/lossesRPR`:
				setSelectedTab("MonthlyLossesRPRReport");
				break;
			case `${basepath}/summary/rpr_python`:
				setSelectedTab("SummaryReportRPRPython");
				break;
			case `${basepath}/summary/accounting`:
				setSelectedTab("SUMMARY");
				break;
			case `${basepath}/summary/msa`:
				setSelectedTab("SUMMARY_MSA");
				break;
			case `${basepath}/issue`:
				setSelectedTab("ISSUE");
				break;
			case `${basepath}/inputevn`:
				setSelectedTab("INPUTEVN");
				break;
			case `${basepath}/inputmsa`:
				setSelectedTab("INPUTMSA");
				break;
			case `${basepath}/site-creation`:
				setSelectedTab("SITECREATION");
				break;
			case `${basepath}/site-creation/manage-site/execution-table`:
				setSelectedTab("SITECREATION");
				break;
			case `${basepath}/site-creation/manage-site/operating-table`:
				setSelectedTab("SITECREATION");
				break;
			case `${basepath}/site-creation/manage-site/construction-table`:
				setSelectedTab("SITECREATION");
				break;
			case `${basepath}/site-creation/manage-site/construction-form`:
				setSelectedTab("SITECREATION");
				break;
			case `${basepath}/site-creation/manage-site/invoicing-info-table`:
				setSelectedTab("SITECREATION");
				break;
			case `${basepath}/site-creation/manage-site/accounting-info-form`:
				setSelectedTab("SITECREATION");
				break;
			case `${basepath}/overview`:
				setSelectedTab("OVERVIEW");
				break;
			case `${basepath}/site-creation/target-table`:
				setSelectedTab("TARGET_TABLE");
				break;
			case `${basepath}/site-creation/target-summary`:
				setSelectedTab("TARGET_SUMMARY");
				break;
			case `${basepath}/site-creation/target-input`:
				setSelectedTab("TARGET_INPUT");
				break;
			case `${basepath}/users/clients`:
				setSelectedTab("USERS_CLIENTS");
				break;
			case `${basepath}/users/GY`:
				setSelectedTab("USERS_KEYCLOAK");
				break;
			case `${basepath}/users/GY/form`:
				setSelectedTab("USERS_KEYCLOAK_FORM");
				break;
			case `${basepath}/upload`:
				setSelectedTab("UPLOAD_DATA");
				break;
			default:
				if (pathname.includes(`${basepath}/users/clients/form/`))
					setSelectedTab("USERS_CLIENTS_FORM");

				break;
		}

		return () => {
			if (!isSingleSiteUser) currentSite.showSelectSites(true);
		};
	}, [isSingleSiteUser, router]);

	useEffect(() => {
		if (!currentSite.showSelect) {
			if (!isSingleSiteUser) {
				if (
					/^\/solar\/administration\/*$/.test(router.pathname) ||
					/^\/solar\/administration\/overview\/*$/.test(router.pathname) ||
					/^\/solar\/administration\/site-creation\/target-table\/*$/.test(
						router.pathname,
					) ||
					/^\/solar\/administration\/site-creation\/target-input\/*$/.test(
						router.pathname,
					)
				) {
					currentSite.showSelectSites(true);
				}
			}
		}
		if (currentSite.showSelect) {
			if (isSingleSiteUser) {
				currentSite.showSelectSites(false);
			}
			if (!isSingleSiteUser) {
				if (
					!/^\/solar\/administration\/*$/.test(router.pathname) &&
					!/^\/solar\/administration\/overview\/*$/.test(router.pathname) &&
					!/^\/solar\/administration\/site-creation\/target-table\/*$/.test(
						router.pathname,
					) &&
					!/^\/solar\/administration\/site-creation\/target-input\/*$/.test(
						router.pathname,
					)
				) {
					currentSite.showSelectSites(false);
				}
			}
		}
	}, [router, currentSite, isSingleSiteUser]);

	const RouterSwitch = useMemo(
		() => (
			<Router>
				<Switch>
					<Route
						exact
						path={`${basepath}/overview`}
						component={() => (
							<RouteProtect requiredRoles={requiredRoles.adminOverview}>
								<AdminOverview selectedSite={selectedSite} />
							</RouteProtect>
						)}
					/>
					<Route
						exact
						path={`${basepath}/download`}
						component={() => (
							<RouteProtect requiredRoles={requiredRoles.downloadContents}>
								<DownloadContents selectedSite={selectedSite} />
							</RouteProtect>
						)}
					/>
					<Route
						exact
						path={`${basepath}/upload`}
						component={() => (
							<RouteProtect requiredRoles={requiredRoles.uploadContents}>
								<UploadDataContents />
							</RouteProtect>
						)}
					/>
					<Route
						exact
						path={`${basepath}/billing`}
						component={() => (
							<RouteProtect requiredRoles={requiredRoles.billingLandingPage}>
								<LandingPage
									title="Welcom to the Billing page"
									subtitle="Please navigate to submenu to perform actions in billing data"
								/>
							</RouteProtect>
						)}
					/>
					<Route
						exact
						path={`${basepath}/billing/invoice`}
						component={() => (
							<RouteProtect requiredRoles={requiredRoles.invoiceContent}>
								<InvoiceContent viewLevel={viewLevel} userDate={userData} />
							</RouteProtect>
						)}
					/>
					<Route
						exact
						path={`${basepath}/billing/payment-record`}
						component={() => (
							<RouteProtect requiredRoles={requiredRoles.paymentRecordVN}>
								<PaymentRecordVN />
							</RouteProtect>
						)}
					/>
					<Route
						exact
						path={`${basepath}/billing/receipt`}
						component={() => (
							<RouteProtect requiredRoles={requiredRoles.receiptContent}>
								<ReceiptContent viewLevel={viewLevel} />
							</RouteProtect>
						)}
					/>
					<Route
						exact
						path={`${basepath}/issue`}
						component={() => (
							<RouteProtect requiredRoles={requiredRoles.issueList}>
								<IssueList />
							</RouteProtect>
						)}
					/>
					<Route
						exact
						path={`${basepath}/issue-calendar`}
						component={() => (
							<RouteProtect requiredRoles={requiredRoles.issueList}>
								<IssueCalendar />
							</RouteProtect>
						)}
					/>
					<Route
						exact
						path={`${basepath}/users`}
						component={() => (
							<RouteProtect requiredRoles={requiredRoles.userLandingPage}>
								<LandingPage
									title="Welcome to User Management page"
									subtitle="Please navigate to submenu to perform actions in user management data"
								/>
							</RouteProtect>
						)}
					/>
					<Route
						exact
						path={`${basepath}/users/clients`}
						component={() => (
							<RouteProtect requiredRoles={requiredRoles.clientUsersContent}>
								<ClientUsersContent />
							</RouteProtect>
						)}
					/>
					<Route
						path={`${basepath}/users/clients/form`}
						component={() => (
							<RouteProtect requiredRoles={requiredRoles.userForm}>
								<UsersForm />
							</RouteProtect>
						)}
					/>
					<Route
						exact
						path={`${basepath}/users/GY`}
						component={() => (
							<RouteProtect requiredRoles={requiredRoles.keycloakPanelContent}>
								<KeycloakPanelContent selectedSite={selectedSite} />
							</RouteProtect>
						)}
					/>
					<Route
						exact
						path={`${basepath}/users/GY/form`}
						component={() => (
							<RouteProtect requiredRoles={requiredRoles.usersFormKC}>
								<UsersFormKC />
							</RouteProtect>
						)}
					/>
					<Route
						exact
						path={`${basepath}/input`}
						component={() => (
							<RouteProtect requiredRoles={requiredRoles.input}>
								<LandingPage
									title="Welcome to Input page"
									subtitle="Please navigate to submenu to perform actions in EVN/MSA inputs"
								/>
							</RouteProtect>
						)}
					/>
					<Route
						exact
						path={`${basepath}/inputevn`}
						component={() => (
							<RouteProtect requiredRoles={requiredRoles.inputEVN}>
								<InputEVN />
							</RouteProtect>
						)}
					/>
					<Route
						exact
						path={`${basepath}/inputmsa`}
						component={() => (
							<RouteProtect requiredRoles={requiredRoles.inputMSA}>
								<InputMSA />
							</RouteProtect>
						)}
					/>
					<Route
						exact
						path={`${basepath}/site-creation`}
						component={() => (
							<RouteProtect requiredRoles={requiredRoles.siteCreation}>
								<LandingPage
									title="Welcome to Site Creation page"
									subtitle="Please navigate to submenu to perform actions in site creation data"
								/>
							</RouteProtect>
						)}
					/>
					<Route
						exact
						path={`${basepath}/site-creation/manage-site/redirect`}
						component={() => (
							<RouteProtect requiredRoles={requiredRoles.siteCreation}>
								<SiteCreationRedirect />
							</RouteProtect>
						)}
					/>
					<Route
						exact
						path={`${basepath}/site-creation/manage-site/execution-table`}
						component={() => (
							<RouteProtect requiredRoles={requiredRoles.siteCreation}>
								<SiteCreationExecutionTable />
							</RouteProtect>
						)}
					/>
					<Route
						exact
						path={`${basepath}/site-creation/manage-site/operating-table`}
						component={() => (
							<RouteProtect requiredRoles={requiredRoles.siteCreation}>
								<SiteCreationOperatingTable />
							</RouteProtect>
						)}
					/>
					<Route
						exact
						path={`${basepath}/site-creation/manage-site/construction-table`}
						component={() => (
							<RouteProtect requiredRoles={requiredRoles.siteCreation}>
								<SiteCreationConstructionTable />
							</RouteProtect>
						)}
					/>
					<Route
						exact
						path={`${basepath}/site-creation/manage-site/construction-form`}
						component={() => (
							<RouteProtect requiredRoles={requiredRoles.siteCreation}>
								<SiteCreationConstructionForm />
							</RouteProtect>
						)}
					/>
					<Route
						exact
						path={`${basepath}/site-creation/manage-site/invoicing-info-table`}
						component={() => (
							<RouteProtect requiredRoles={requiredRoles.siteCreation}>
								<SiteCreationInvoicingInfoTable />
							</RouteProtect>
						)}
					/>
					<Route
						exact
						path={`${basepath}/site-creation/manage-site/invoicing-info-form`}
						component={() => (
							<RouteProtect requiredRoles={requiredRoles.siteCreation}>
								<SiteCreationInvoicingForm />
							</RouteProtect>
						)}
					/>
					<Route
						exact
						path={`${basepath}/site-creation/target-input`}
						component={() => (
							<RouteProtect requiredRoles={requiredRoles.targetInputs}>
								<TargetInputs selectedSite={selectedSite} />
							</RouteProtect>
						)}
					/>
					<Route
						exact
						path={`${basepath}/site-creation/target-summary`}
						component={() => (
							<RouteProtect requiredRoles={requiredRoles.targetView}>
								<TargetViewSummary />
							</RouteProtect>
						)}
					/>
					<Route
						exact
						path={`${basepath}/site-creation/target-table`}
						component={() => (
							<RouteProtect requiredRoles={requiredRoles.targetView}>
								<TargetView selectedSite={selectedSite} />
							</RouteProtect>
						)}
					/>
					{!!viewLevel && (
						<>
							<Route
								exact
								path={`${basepath}/summary`}
								component={() => (
									<RouteProtect requiredRoles={requiredRoles.summaryReport}>
										<LandingPage
											title="Welcome to Summary Report page"
											subtitle="Please navigate to submenu to perform actions in summary report data"
										/>
									</RouteProtect>
								)}
							/>
							<Route
								exact
								path={`${basepath}/summary/accounting`}
								component={() => (
									<RouteProtect requiredRoles={requiredRoles.summaryReport}>
										<SummaryReport viewLevel={viewLevel} />
									</RouteProtect>
								)}
							/>
							<Route
								exact
								path={`${basepath}/summary/msa`}
								component={() => (
									<RouteProtect requiredRoles={requiredRoles.summaryReportMSA}>
										<SummaryReportMSA viewLevel={viewLevel} />
									</RouteProtect>
								)}
							/>
							<Route
								exact
								path={`${basepath}/summary/ops`}
								component={() => (
									<RouteProtect requiredRoles={requiredRoles.summaryReportOps}>
										<SummaryReportOps viewLevel={viewLevel} />
									</RouteProtect>
								)}
							/>
							<Route
								exact
								path={`${basepath}/summary/newom`}
								component={() => (
									<RouteProtect requiredRoles={requiredRoles.summaryReportOps}>
										<SummaryReportOM viewLevel={viewLevel} />
									</RouteProtect>
								)}
							/>
							<Route
								exact
								path={`${basepath}/summary/lossesRPR`}
								component={() => (
									<RouteProtect
										requiredRoles={requiredRoles.monthlyLossesRPRReport}
									>
										<MonthlyLossesRPRReport viewLevel={viewLevel} />
									</RouteProtect>
								)}
							/>
							<Route
								exact
								path={`${basepath}/summary/rpr_python`}
								component={() => (
									<RouteProtect
										requiredRoles={requiredRoles.SummaryReportRPRPython}
									>
										<SummaryReportRPRPython />
									</RouteProtect>
								)}
							/>
						</>
					)}
				</Switch>
			</Router>
		),
		[selectedSite, viewLevel, requiredRoles],
	);

	return (
		<div className="container90">
			{/* Admin contents */}
			<Row noGutters={true}>
				<h2
					style={{ fontSize: "45px", textAlign: "center", padding: "25px 0" }}
				>
					<span className="glyphicon glyphicon-cog" aria-hidden="true"></span>
					Administration Panel
				</h2>
			</Row>
			<Row noGutters={true}>
				<Col xs={2} md={2}>
					<div
						className="list-group"
						style={{ fontSize: "13px", overflowX: "hidden" }}
					>
						<div className="list-group-item active main-color-bg">
							<span
								className="glyphicon glyphicon-dashboard"
								aria-hidden="true"
							></span>{" "}
							Dashboard
						</div>

						{navBarItems.map(renderNavBarItem).filter((item) => item)}
					</div>
				</Col>
				<Col xs={10} md={10}>
					<div
						className="perf-table panel panel-default"
						style={{ paddingBottom: "1px" }}
					>
						<ProvideKeycloakUsersForm>
							<ProvideClientUsersForm>{RouterSwitch}</ProvideClientUsersForm>
						</ProvideKeycloakUsersForm>
					</div>
				</Col>
			</Row>
		</div>
	);
}

export default AdminContents;
